'use strict';

(function (window, document) {
    /**
     * Runs the given function when the DOM is ready.
     * @param {function} fn - The function to run.
     * @param {Object=} context - The context in which to run the function.
     */
    function DOMReady(fn, context) {
        /**
         * DOMContentLoaded event handler.
         * @param {Event} event - The DOMContentLoaded event.
         */
        function onReady(event) {
            document.removeEventListener('DOMContentLoaded', onReady);
            fn.call(context || window, event);
        }

        document.addEventListener('DOMContentLoaded', onReady);
    }

    /**
     * Bind ID.me widgets to the page.
     *
     * When the function is called, it will find all elements with the class
     * 'idme-wallet-button', build a URL based on the data attributes of each
     * element, and replace the element with a link to the built URL.
     *
     * @example
     * <span class="idme-wallet-button" data-scope="profile" data-client-id="1234567890" data-redirect="https://example.com/callback"></span>
     *
     * Will be replaced with:
     *
     * <a class="idme-trigger-link" href="https://api.id.me/oauth/authorize?scope=profile&client_id=1234567890&redirect_uri=https://example.com/callback&response_type=code&state=">
     *     <img src="https://d2ve5f5nu8u78q.cloudfront.net/images/idme-verify.svg" alt="ID.me Logo"/>
     * </a>
     */
    function BindIDme() {
        var buttons = document.getElementsByClassName('idme-wallet-button');

        /**
         * Opens the ID.me authentication link in a new window.
         * @param {Element} link - The link element that was clicked.
         * @param {Event} e - The click event.
         *
         * Centers the new window on the screen, and sets its size to 775x850 pixels.
         * The new window is given the name "ID.me".
         * The new window is given focus if the browser allows it.
         */
        var clickHandler = function (link, e) {
            e.preventDefault();
            const parentWidth = window.innerWidth;
            const parentHeight = window.innerHeight;
            const width = 775;
            const height = 850;
            var screenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
            var screenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

            var left = ((parentWidth / 2) - (width / 2)) + screenLeft;
            var top = ((parentHeight / 2) - (height / 2)) + screenTop;

            var opened = window.open(link, 'ID.me', 'scrollbars=yes, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);

            if (window.focus) opened.focus();
        };

        for (var i = 0; i < buttons.length; i++) {
            var button = buttons[i];
            var scope = button.getAttribute('data-scope');
            var client = button.getAttribute('data-client-id');
            var redirect = button.getAttribute('data-redirect');
            var response = button.getAttribute('data-response');
            var state = button.getAttribute('data-state');
            var display = button.getAttribute('data-display');
            var logo = button.getAttribute('data-logo');
            var hero = button.getAttribute('data-hero');
            var text = button.getAttribute('data-text');
            var printText = button.previousElementSibling;
            var hasPrintText = printText.classList.contains('idme-print');
            var verify = button.getAttribute('data-show-verify');
            var hlp = button.getAttribute('data-hlp');
            var type = button.getAttribute('data-type');
            var country = button.getAttribute('data-country');
            var language = button.getAttribute('data-language');
            var appId = button.getAttribute('data-app-id');
            var idmeLogo = button.getAttribute('data-idmelogo');
            var multiple = scope.split(',').length > 1;

            // build widget parameters
            var params = '';

            if (scope && multiple) {
                params += '&scopes=' + scope;
            } else {
                params += '&scope=' + scope;
            }

            if (hlp) params += '&hlp=' + hlp;
            if (hero) params += '&hero_url=' + hero;
            if (logo) params += '&logo_url=' + logo;
            if (state) params += '&state=' + state;
            if (client) params += '&client_id=' + client;
            if (redirect) params += '&redirect_uri=' + redirect;
            if (response) params += '&response_type=' + response;
            if (country) params += '&country=' + country;
            if (language) params += '&language=' + language;
            if (appId) params += '&appid=' + appId;

            if (type) {
                params += '&type=' + type;
            } else {
                params += '&type=button';
            }

            params += '&source=idme_widget_old';
            params += '&current_url=' + window.location.origin + window.location.pathname;

            var buttonLink = null;

            if (hlp) {
                buttonLink = hlp;
            } else if (multiple) {
                buttonLink = 'https://groups.id.me/?' + params;
            } else {
                buttonLink = 'https://api.id.me/oauth/authorize?' + params;
            }

            var container = document.createElement('span');
            var trigger = document.createElement('div');
            var buttonElem = document.createElement('a');
            // var description = document.createElement('span');

            container.className = 'idme-verification';
            trigger.className = 'idme-trigger';
            buttonElem.className = 'idme-trigger-link idme-unify-button';
            // description.className = 'idme-description'

            // description.innerHTML = 'Verification by ID.me â€¢ <a href='https://www.id.me/about' target='_new'>What is ID.me?</a>'

            // display offer text if present
            var offer = '';
            if (hasPrintText && printText.innerText && printText.innerText.trim() !== '') {
                offer = document.createElement('span');

                offer.className = 'idme-text';
                offer.appendChild(printText.firstElementChild);

                trigger.appendChild(offer);
            } else if (text) {
                offer = document.createElement('span');

                offer.className = 'idme-text';
                offer.innerHTML = text;

                trigger.appendChild(offer);
            }

            // toggle popup user experience
            if (display === 'popup') {
                buttonElem.href = buttonLink;
                buttonElem.onclick = clickHandler.bind(this, buttonLink);
            } else {
                buttonElem.href = buttonLink;
                buttonElem.target = '_parent';
            }

            buttonElem.innerHTML = '<img src="' + idmeLogo + '" height="35" width="179" alt="ID.me Logo"/>';

            // insert button element before offer
            trigger.insertBefore(buttonElem, trigger.firstChild);

            // display what is ID.me show verify true
            if (verify) {
                var description = document.createElement('span');

                description.className = 'idme-description';
                description.innerHTML = 'Verification by ID.me â€¢ <a href="https://www.id.me/about" target="_new">What is ID.me?</a>';

                trigger.appendChild(description);
            }

            container.appendChild(trigger);

            // insert after widget
            button.parentNode.insertBefore(container, button.nextSibling);

            // remove widget
            button.remove();
        }
    }

    window.bindIDme = BindIDme;
    window.domReady = DOMReady;
}(window, document));

window.domReady(window.bindIDme);
